// Bendras parduotuvės kategorijų / filtrų šaltinis.
// Naudoja ir Header (kategorijų meniu), ir Catalog (filtrai) — kad nesiskirtų.

export const MATERIALS = ["PLA", "PLA Matte", "PLA Silk", "PETG", "PETG-CF", "ABS", "TPU"];

const f = (k, v) => `/parduotuve?${k}=${encodeURIComponent(v)}`;

// Iššokančio kategorijų meniu struktūra (stulpeliai)
export const SHOP_MENU = [
  {
    title: "Pagal medžiagą",
    items: [
      { label: "PLA", to: f("material", "PLA") },
      { label: "PETG", to: f("material", "PETG") },
      { label: "ABS", to: f("material", "ABS") },
      { label: "TPU (lankstus)", to: f("material", "TPU") },
    ],
  },
  {
    title: "Specialūs / efektai",
    items: [
      { label: "PLA Matte (matinis)", to: f("material", "PLA Matte") },
      { label: "PLA Silk (blizgus)", to: f("material", "PLA Silk") },
      { label: "PETG-CF (karbonas)", to: f("material", "PETG-CF") },
    ],
  },
];
